var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-section" },
    [
      _c("h5", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "md-field",
        [
          _c("label", [_vm._v(_vm._s(_vm.placeholder))]),
          _c("md-input", {
            on: { input: _vm.emitChange },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }